import React, {useEffect, useState} from 'react';
import foldersApi from "../../services/api/folders";
import FolderRow from "../widgets/FolderRow";
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';

const FolderSelection = ({currentFolder, setCurrentFolder, entity}) => {
  const [folders, setFolders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [folderAbove, setFolderAbove] = useState(null);
  const [currentFolderName, setCurrentFolderName] = useState('');

  useEffect(() => {
    getCurrentFolders();
    if (currentFolder) {
      getFolderName();
    } else {
      setCurrentFolderName('Home');
    }
  }, [currentFolder]);

  const getCurrentFolders = async () => {
    try {
      const {data} = await foldersApi.find({folderAbove: currentFolder});
      setFolders(data.folders);
      if (data.folderAbove) {
        setFolderAbove(data.folderAbove);
      } else {
        setFolderAbove('');
      }
    } catch (e) {
      console.log('ERROR:', e);
      // TODO: Show error if can't fetch
    } finally {
      setIsLoading(false);
    }
  };

  const getFolderName = async () => {
    try {
      const {data} = await foldersApi.names({ids: [currentFolder]});
      setCurrentFolderName(data[0].name);
    } catch (e) {
      console.log('ERROR:', e);
    }
  };

  const goBack = () => {
    setIsLoading(true);
    setCurrentFolder(folderAbove || '');
  };

  const goForward = id => {
    setIsLoading(true);
    setCurrentFolder(id);
  };

  return (
    <>
      <div className="breadcrumbs">
        <p>{!isLoading && currentFolderName ? currentFolderName : <Skeleton width={100} height={17} />}</p>
      </div>
      <div className="folder-selection">
        {currentFolder && !isLoading && <FolderRow goBack={goBack}/>}
        {folders && !isLoading ? folders.map(folder => {
          if (folder.id !== entity.id) {
            return (
              <FolderRow
                folder={folder}
                key={folder.id}
                goForward={goForward}
              />
            );
          }
        }) : (
          <SkeletonTheme color="#f4f4f4" highlightColor="#fafafa">
            <Skeleton count={3} height={45}/>
          </SkeletonTheme>
        )}
      </div>
    </>
  );
};

export default FolderSelection;
